/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_No_ContentInputs */

const es_feedback_modal_no_content = /** @type {(inputs: Feedback_Modal_No_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin contenido`)
};

const en_feedback_modal_no_content = /** @type {(inputs: Feedback_Modal_No_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No content`)
};

/**
* | output |
* | --- |
* | "No content" |
*
* @param {Feedback_Modal_No_ContentInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_no_content = /** @type {((inputs?: Feedback_Modal_No_ContentInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_No_ContentInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_no_content(inputs)
	return en_feedback_modal_no_content(inputs)
});
export { feedback_modal_no_content as "feedback.modal.no_content" }